import { render, staticRenderFns } from "./StateDeviceTypeTable.vue?vue&type=template&id=12d99f9c&scoped=true&"
import script from "./StateDeviceTypeTable.vue?vue&type=script&lang=ts&"
export * from "./StateDeviceTypeTable.vue?vue&type=script&lang=ts&"
import style0 from "./StateDeviceTypeTable.vue?vue&type=style&index=0&id=12d99f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d99f9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
